import React, {useRef, useState} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import ErrorIcon from "@mui/icons-material/Error";

import {featureInterface} from "../../../../../interfaces/featureInterface";
import LookFeatureMatchingStyleAlertModal from "./lookFeatureMatchingStyleAlertModal";
import {getStyleAlertNotMatchingFeatures} from "../../lookFunctions";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";

const LookFeatureMatchingStyleAlert = (props) => {

  const {intl, lookFeature, lookRemovedCartItems} = props;
  const anchorRef = useRef(null);
  const [styleAlertModalOpened, setStyleAlertModalOpened] = useState(false);

  if (IS_PRODUCT_JOURNEY) {
    return null
  }

  const deletedFromCart = !!lookRemovedCartItems.length && lookRemovedCartItems.some(cartItem => {
    return (cartItem.partId === lookFeature.partId) && (!lookFeature.metaData.layerPosition
      || (cartItem.cartFeature.metaData.layerPosition === lookFeature.metaData.layerPosition))
  })

  if (!deletedFromCart && !getStyleAlertNotMatchingFeatures(lookFeature, true).length) {
    return null
  }

  const showStyleMatching = () => {
    setStyleAlertModalOpened(!styleAlertModalOpened);
  }

  return (
    <div className="lk-title__action" ref={anchorRef}>
      <IconButton aria-label={intl.formatMessage({id:"iconButton.back"})}
                  className="look-icon look-icon--small look-icon--yellow"
                  onClick={showStyleMatching}>
        <ErrorIcon/>
      </IconButton>
      <LookFeatureMatchingStyleAlertModal anchorEl={anchorRef}
                                          lookFeature={lookFeature}
                                          styleAlertModalOpened={styleAlertModalOpened}
                                          deletedFromCart={deletedFromCart}
                                          setStyleAlertModalOpened={setStyleAlertModalOpened} />
    </div>
  )
};

LookFeatureMatchingStyleAlert.propTypes = {
  lookFeature: PropTypes.shape(featureInterface).isRequired,
}

const mapStateToProps = (store) => {
  const {lookActiveFeature, moreInfoOpened, moreInfoContent, lookOverlayOpened} = store.lookState;
  const {canvasCount} = store.bathroomVisualizerState;
  const {lookRemovedCartItems} = store.cartState;
  return {
    lookActiveFeature,
    moreInfoOpened,
    moreInfoContent,
    canvasCount,
    lookOverlayOpened,
    lookRemovedCartItems,
  };
};

const mapDispatchToProps = {
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookFeatureMatchingStyleAlert)
)
